import { getRequestHeaders, handleRes, logError } from "utils";

import { EntityTypes } from "types";
import { FileMetadata } from "types/File";

interface GetEntityQRCodesParams {
  tenantID: string;
  body: string;
  qrCodeID: string;
  entityType: EntityTypes;
  entityID: string;
}
interface UpsertEntityQRCodesParams {
  tenantID: string | undefined;
  body: string;
  qrCodeID: string;
  entityType: EntityTypes;
  entityID: string | undefined;
}

export const getEntityQRCodes = ({
  tenantID,
  entityID,
  entityType,
}: GetEntityQRCodesParams): Promise<FileMetadata[]> => {
  return fetch(
    `${window.QR_CODE_BASE_URL}/tenant/${tenantID}/${entityType}/${entityID}/qr-code`,
    {
      method: "GET",
      ...getRequestHeaders(),
    },
  )
    .then((res) => handleRes<FileMetadata[]>(res, 200))
    .catch((e) => {
      logError(e);
      return [];
    });
};

export const upsertEntityQRCodes = async ({
  tenantID,
  entityType,
  entityID,
  body,
}: UpsertEntityQRCodesParams): Promise<Response> => {
  return await fetch(
    `${window.QR_CODE_BASE_URL}/tenant/${tenantID}/${entityType}/${entityID}/qr-code`,
    {
      method: "PUT",
      ...getRequestHeaders(),
      body,
    },
  );
};

interface UpdateQRCodeParams {
  tenantID: number | string | undefined;
  entityType:
    | EntityTypes.Property
    | EntityTypes.PropertyGroup
    | EntityTypes.Tenant
    | EntityTypes.None;
  entityID: number | string | undefined;
  QRCodeID: number | string | undefined;
  body: string; // PermitType[] as Json string
}
export const updateQRCode = async ({
  tenantID,
  entityType,
  entityID,
  QRCodeID,
  body,
}: UpdateQRCodeParams): Promise<Response> => {
  return await fetch(
    `${window.QR_CODE_BASE_URL}/tenant/${tenantID}/${entityType}/${entityID}/qr-code/${QRCodeID}`,
    {
      method: "PUT",
      ...getRequestHeaders(),
      body,
    },
  );
};

interface DeleteQRCodeParams {
  tenantID: number | string | undefined;
  entityType:
    | EntityTypes.Property
    | EntityTypes.PropertyGroup
    | EntityTypes.Tenant
    | EntityTypes.None;
  entityID: number | string | undefined;
  QRCodeID: number | string | undefined;
  body: string;
}
export const deleteQRCode = async ({
  tenantID,
  entityType,
  entityID,
  QRCodeID,
  body,
}: DeleteQRCodeParams): Promise<Response> => {
  let idToUse: string;
  if (QRCodeID) {
    idToUse = QRCodeID.toString();
  } else {
    const qrCodeBody = JSON.parse(body);
    idToUse = qrCodeBody.fileKey;
  }

  return await fetch(
    `${window.QR_CODE_BASE_URL}/tenant/${tenantID}/${entityType}/${entityID}/qr-code/${idToUse}`,
    {
      method: "DELETE",
      ...getRequestHeaders(),
      body,
    },
  );
};
